import React from "react";
import { StyledTable, WrapperTable } from "./Table.style";
import { defaultTo, get } from "lodash";
import clsx from "clsx";
import { Text } from "src/components/ui/Text";

const Table = ({ data, columns, onClickRow }) => {
  return (
    <WrapperTable>
      <StyledTable>
        <thead>
          <tr>
            {defaultTo(columns, []).map((column) => (
              <th
                data-theme="main"
                className="bg-primary-content normal-case text-sm font-normal text-secondary border-quartenary border-b max-w-max !py-3"
                style={{ width: column?.columnsWidth }}
                key={column.key}
              >
                {column?.renderHead
                  ? column.renderHead({ label: column.label })
                  : column?.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {defaultTo(data, []).map((item, index) => {
            return (
              <tr key={index}>
                {defaultTo(columns, [])?.map((column) => (
                  <th
                    onClick={
                      typeof onClickRow === "function" &&
                      column?.label !== "Actions"
                        ? () => onClickRow(item)
                        : () => {}
                    }
                    data-theme="main"
                    className={`text-sm font-normal text-[#666666] border-quartenary  ${clsx(
                      {
                        [`min-w-[${column?.minWidth}]`]: column?.minWidth,
                        [`max-w-[${column?.maxWidth}]`]: column?.maxWidth,
                        [`w-[${column?.width}]`]: column?.width,
                        "cursor-pointer": typeof onClickRow === "function",
                      }
                    )} `}
                    key={column.key}
                  >
                    {column?.renderBody
                      ? column.renderBody({
                          value: get(item, `${column.key}`),
                          row: item,
                        })
                      : get(item, `${column.key}`)}
                  </th>
                ))}
              </tr>
            );
          })}
        </tbody>
      </StyledTable>
      {!data?.length && (
        <div className="min-h-[22.5rem]">
          <Text
            variant="medium-16"
            className="text-quartenary text-center min-h-[300px] flex items-center justify-center"
          >
            Data Not Found
          </Text>
        </div>
      )}
    </WrapperTable>
  );
};

export default Table;
